module.exports = __webpack_public_path__ + "static/media/bottle-01.75881232.png";